<template>
  <Box>
    <div class="main-container">
      <h3>Aulas práticas com pendências</h3>

      <div class="main-content">
        <form @submit.prevent="handleSubmit" class="main-form">
          <div class="inputs">
            <div class="inputs-row">
              <Select
                class="input-full"
                :options="schemaOptions"
                legend="Auto escola"
                placeholder="Selecione um opção"
                :modelValue="schema"
                @update:modelValue="$event => (schema = $event)"
                :disabled="loading"
              />
            </div>

            <div class="inputs-row">
              <Period
                legend="Data"
                :firstModelValue="dateI"
                :secondModelValue="dateF"
                @update:firstModelValue="$event => (dateI = $event)"
                @update:secondModelValue="$event => (dateF = $event)"
                :disabled="loading"
              />
            </div>

            <div class="buttons">
              <Button
                type="button"
                @handle:click="clearInputs"
                text="Limpar"
                :fill="false"
                color="danger"
                :disabled="loading"
              >
                <CloseCircleOutline :size="18" />
              </Button>

              <Button type="submit" text="Consultar" color="primary" :disabled="loading">
                <Magnify :size="18" />
              </Button>
            </div>
          </div>
        </form>

        <div>
          <div class="chartCard">
            <div class="chartBox">
              <canvas :id="pendeciasChartID"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Box>
</template>

<script>
import Box from 'core/Box'
import Button from 'core/Button'
import Period from 'core/Period'
import Select from 'core/Select'

import CloseCircleOutline from 'icons/CloseCircleOutline'
import Magnify from 'icons/Magnify'

import { pendenciasPraticasChart } from './charts/PendenciasPraticasChart'

export default {
  name: 'PendenciasPraticasGraphic',
  components: {
    Box,
    Select,
    Period,
    Button,

    CloseCircleOutline,
    Magnify,
  },
  data() {
    return {
      schema: null,
      dateI: '',
      dateF: '',
      schemaOptions: [],
      loaded: false,
      loading: false,

      pendeciasChartID: 'pendeciasChart',
    }
  },
  async created() {
    await this.fetchCfcs()

    this.loaded = true
  },
  methods: {
    async fetchCfcs() {
      await this.$http
        .get(`${process.env.VUE_APP_URL_API_V2}/autoescola/todas`)
        .then(res => {
          this.schemaOptions = res.body.dados.map(cfc => ({
            value: cfc.tenant_schema,
            text: cfc.nome_fantasia,
          }))
        })
        .catch(error => {
          this.$toasted.show('Erro!' + error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    clearInputs() {
      this.schema = null
      this.dateI = ''
      this.dateF = ''
    },
    async handleSubmit() {
      if (!this.schema) {
        this.$toasted.show('Selecione uma auto escola.', {
          position: 'top-right',
        })

        return
      }

      if (!this.dateI || !this.dateF) {
        this.$toasted.show('Preencha os campos de data.', {
          position: 'top-right',
        })

        return
      }

      this.loading = true

      const params = {
        schema: this.schema,
        periodoI: this.dateI,
        periodoF: this.dateF,
      }

      await this.$http
        .get(`${process.env.VUE_APP_URL_API_V2}/dashboard/graficos/praticas-pendencias`, {
          params,
        })
        .then(({ body }) => {
          const result = Object.values(body.dados)

          let dados = [
            {
              status: 'Sem registros.',
              quantidades: 1,
            },
          ]

          if (result.length) {
            dados = result.map(item => {
              return {
                status: item.status,
                quantidades: item.quantidade,
              }
            })
          }

          pendenciasPraticasChart.createChart(this.pendeciasChartID, dados)
        })
        .catch(({ body }) => {
          this.$toasted.show(body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.main-container {
  h3 {
    margin-bottom: 1rem;
    font-weight: 700;
    font-size: 1.375rem;
    color: #202224;
  }

  .main-content {
    display: flex;
    flex-wrap: wrap;
    gap: 3rem;

    > div {
      flex: 1;
    }

    .main-form {
      flex: 1;
      max-width: 24rem;

      .inputs {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        .inputs-row {
          .inputs-full {
            flex: 1;
          }
        }

        .buttons {
          margin-top: 1rem;
          display: flex;
          gap: 1rem;
        }
      }
    }
  }
}

.chartCard {
  display: flex;
  align-items: center;
  justify-content: center;
}

.chartBox {
  width: 100%;
  padding: 20px;
  background: white;
}
</style>
